<template>
  <div class="menu unselect" v-if="hideMenu">
    <div class="menu__buttons">
      <router-link
        to="/"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
      >
        {{ $t('menu.accounts') }}
      </router-link>
      <router-link
        to="/tokens"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >{{ $t('menu.tokens') }}
      </router-link>
      <router-link
        to="/cookies"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >{{ $t('menu.cookies') }}
      </router-link>
      <router-link
        to="/converter"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >{{ $t('menu.converter') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',

  computed: {
    hideMenu() {
      return this.$route.name !== 'Login' &&
        this.$route.name !== 'Register' &&
        this.$route.name !== 'RestorePassword' &&
        this.$route.name !== 'Dashboard' &&
        this.$route.name !== 'DashboardChecks' &&
        this.$route.name !== 'DashboardDonors' &&
        this.$route.name !== 'DashboardImport' &&
        this.$route.name !== 'DashboardSettings' &&
        this.$route.name !== 'DashboardLogin' &&
        this.$route.name !== 'DashboardDonor' &&
        this.$route.name !== 'DashboardProxy'
        ? true
        : false;
    }
  }
};
</script>

<style scoped>
.menu {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  /* margin: 46px 0 0 0; */
  /* padding: 0px 15px;
  background: #f1f1f1; */
  padding: 5px 15px;
  background: #eeeded;
}

.menu__buttons {
  display: flex;
  align-items: center;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.menu__buttons::-webkit-scrollbar {
  display: none;
}

.menu__btn {
  /* display: none; */
  align-items: center;
  /* position: fixed; */
  /* right: 10px; */
  /* width: 26px; */
  /* height: 26px; */
  cursor: pointer;
  padding: 5px 10px;
  cursor: pointer;
  margin: 0 5px 0 0;
  font-family: inherit;
  border: 0;
  font-size: 16px;
  outline: 0;
  color: #262a2d;
  /* background: #333; */
  text-decoration: none;
}

.menu__btn-active,
.menu__btn:hover {
  /* background: #333333; */
  background: #5a5a5a;
  color: #ffffff;
  border-radius: 5px;
}
</style>